import { apiClient } from 'src/lib/apiClient';

export interface Subscription {
  id: number;
  merchant_id: number;
  merchant: {
    name: string;
  };
  subscription_token: string;
  status: string;
  billing_date: string;
  system_paused_notice_count: number;
  overdue_notice_sent: boolean;
  pf_amount: number | null;
  pf_cycles: number | null;
  pf_cycles_complete: number | null;
  pf_frequency: number | null;
  pf_status: string | null;
  pf_status_reason: string | null;
  pf_synced_at: string | null;
  createdAt: string;
  updatedAt: string;
  stampCount?: number; // For FREE_TRIAL subscriptions - indicates trial progress
}

/**
 * This used to wrap the request in a localStorage cache with a 5-minute TTL, a
 * `forceRefresh` flag threaded through callers, and a `getCacheInfo()` the admin
 * UI read to show cache age. The query cache does all of that now: freshness is
 * `staleTimes.stats`, a forced refresh is `refetch()`, and the age readout comes
 * from the query's own `dataUpdatedAt`.
 *
 * Dropping it also removes a real hazard — the cached payload outlived sign-out,
 * so it could be served to whoever signed in next.
 */
export const subscriptionService = {
  getAllSubscriptions: async (): Promise<Subscription[]> => {
    const response = await apiClient.get('subscriptions');
    return response.data;
  },

  syncWithPayfast: async (): Promise<void> => {
    await apiClient.post('subscriptions/sync');
  },
};
